import {
  MONTHLY_TERM,
  PACKAGE_CARD_DESCRIPTIONS,
  PACKAGE_CARD_IS_POPULAR,
  PACKAGE_CARD_SUBHEADERS,
  PACKAGE_HIGHLIGHTS,
  PACKAGE_NAME_VARIATIONS,
  PACKAGE_TITLES,
  PACKAGES,
  YEARLY_TERM,
} from './constants';
import {
  ESSENTIALS_PAID_PLAN,
  PODIUM_PAID_PLAN,
  PROFESSIONAL_PAID_PLAN,
} from '../../screens/Trials/constants';

export const getBundleCardProps = (bundleName) => ({
  bundleName,
  description: PACKAGE_CARD_DESCRIPTIONS[bundleName],
  header: PACKAGE_TITLES[bundleName],
  highlights: PACKAGE_HIGHLIGHTS[bundleName],
  popularText: PACKAGE_CARD_IS_POPULAR[bundleName] && 'Most popular',
  subHeader: PACKAGE_CARD_SUBHEADERS[bundleName],
});

export const handleOnToggleFeatureList = (
  plan,
  trackEvent,
  trackEventPath = ''
) => {
  if (!trackEvent) {
    return;
  }

  const trackEventPathEnd = plan
    ? 'seeEachCardFeaturesOpened'
    : 'seeAllFeaturesOpened';
  const trackEventFullPath = `${trackEventPath}.${trackEventPathEnd}`;
  const trackEventOptions = plan ? { plan } : {};

  trackEvent(trackEventFullPath, trackEventOptions);
};

const findPricesByBundle = ({ allPrices = [], bundlePlan } = {}) =>
  allPrices?.find((bundlePrice = {}) => bundlePrice.bundleSlug === bundlePlan);

const filterPricesByTerm = ({ allPrices = [], term = MONTHLY_TERM } = {}) =>
  allPrices?.filter((bundlePrice = {}) => bundlePrice.term === term);

export const buildPackagePrices = (allPrices = []) => ({
  [PACKAGES.ESSENTIALS]: findPricesByBundle({
    allPrices,
    bundlePlan: ESSENTIALS_PAID_PLAN,
  }),
  [PACKAGES.PROFESSIONAL]: findPricesByBundle({
    allPrices,
    bundlePlan: PROFESSIONAL_PAID_PLAN,
  }),
  [PACKAGES.STANDARD]: findPricesByBundle({
    allPrices,
    bundlePlan: PODIUM_PAID_PLAN,
  }),
});

export const buildPackagePricesByTerm = (allPrices = []) => {
  if (allPrices?.length < 1) {
    return;
  }

  const monthlyPrices = filterPricesByTerm({
    allPrices: JSON.parse(JSON.stringify(allPrices)),
  });
  const yearlyPrices = filterPricesByTerm({
    allPrices: JSON.parse(JSON.stringify(allPrices)),
    term: YEARLY_TERM,
  });

  return {
    [MONTHLY_TERM]: buildPackagePrices(monthlyPrices),
    [YEARLY_TERM]: buildPackagePrices(yearlyPrices, YEARLY_TERM),
  };
};

export const getAllSelectedBundlePrices = ({
  bundleName,
  monthlyPackagePrices,
  yearlyPackagePrices,
} = {}) => {
  if (!monthlyPackagePrices || !yearlyPackagePrices) {
    return {};
  }

  const standardPlanName = PACKAGE_NAME_VARIATIONS[bundleName];

  return {
    monthlyPrices: monthlyPackagePrices[standardPlanName],
    yearlyPrices: yearlyPackagePrices[standardPlanName],
  };
};

export const getSelectedTermBundlePrice = ({
  bundleName,
  isAnnual,
  monthlyPackagePrices,
  yearlyPackagePrices,
} = {}) => {
  const { monthlyPrices, yearlyPrices } = getAllSelectedBundlePrices({
    bundleName,
    monthlyPackagePrices,
    yearlyPackagePrices,
  });

  return isAnnual ? yearlyPrices?.price : monthlyPrices?.price;
};

export const getAnnualSavings = ({ annualPrices, monthlyPrices } = {}) => {
  const yearlyPrice = annualPrices?.discountPrice || annualPrices?.price;

  return (monthlyPrices?.price - yearlyPrice) * 12;
};
